module.exports = __webpack_public_path__ + "img/capa.07d69b6f.png";